import { useMutation } from "@tanstack/react-query";
import TenantAPI from "../../api/TenantAPI";
import { newToastEvent } from "../../../utils/ToastUtil";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";

interface Props {
  moduleAPIName: string;
  payload: Record<string, any>[];
  onCreate: (r: any) => void;
  onError: (err: string) => void;
}

const useCreateRecords = () => {
  const createRecords = useMutation({
    mutationFn: ({ moduleAPIName, payload }: Props) => {
      return TenantAPI.insertRecords(moduleAPIName, payload);
    },
    onSuccess: (_, { onCreate }) => {
      // queryClient.invalidateQueries({
      //   queryKey: ["records", module.APIName],
      // });

      callFunctionIfExists(onCreate);
    },
    onError: (e, { onError }) => {
      onError(getErrorMessage(e));

      newToastEvent(
        "error",
        "We were unable to create the records. Please Try again."
      );
    },
  });

  return {
    createRecords: createRecords.mutate,
    recordsCreating: createRecords.isPending,
    createRecordsError: createRecords.error
      ? getErrorMessage(createRecords.error)
      : null,
    clearError: createRecords.reset,
  };
};

export default useCreateRecords;
